export let tableHeader = [
  {
    A: "",
    B: "Project",
    C: "Slip Date",
    D: "Plant",
    E: "Slip No ",
    F: "Cancelled",
    G: "Joint",
    H: "WPS No",
    I: "Process",
    J: "Type",
    K: "Welder Code",
    L: "Welder Name",
  },
];

export let prodReportHeader = [
  {
    A: "",
    B: "Project",
    C: "Slip Date",
    D: "Plant",
    E: "Slip No ",
    F: "Cancel Status",
    G: "Joint Type",
    H: "WPS",
    I: "Process",
    J: "Type",
    K: "Welder Code",
    L: "Welder Name",
    M: "Slip Created By",
    N: "Item Code",
    O: "Item Desc",
    P: "Item Group",
    Q: "WCinKgs",
    R: "WMinKgs",
  },
];
